
import { Content, Views, FailureType } from "../Types/AppStateTypes";
import { ErrorButtons, ErrorPropsV2 } from "../lib/types";
import Error from '../lib/components/ErrorV2'
import { useDispatch, useSelector } from "react-redux";
import { IADPState } from "Types/AppStateTypes";
import { createSetExitAction, createSetHomeAction, createTryAgainAction } from "state/reducer";
import { SplitLayout } from "components/SplitLayout";
import errorTriangle from '../assets/red_triangle_exclamation.svg'
export default function FailureView() {
  const state = useSelector((state:{rootState:IADPState})=>state.rootState)
  const dispatch = useDispatch()
  const content = useSelector((state:{rootState:IADPState})=>state.rootState.currentLanguageContent)
  const errorType:FailureType = state.sessionState.failure || "ApplicationError"
  const errorContent = useSelector((state:{rootState:IADPState})=>state.rootState.currentLanguageContent?.error[errorType])
  const handleCancel = () =>{
    dispatch(createSetHomeAction())
  }
  const handleExit = () =>{
    dispatch(createSetExitAction());
  } 
  const tryAgain =()=>{
    if(state.sessionState.lastKnownGoodState === "LoadingView")window.location.reload()
    else{
            dispatch(createTryAgainAction());
    }
    
  }
  const getButtonProps =(errorType:FailureType):ErrorButtons[] => {
    switch(errorType){
        case "ApplicationError" : 
        {
            return [
                    {
                        label: content?.actions.exit || "Exit Application",
                        action: handleExit,
                        variant: "secondary",
                        key:0
                    }
                ]
        }
        case "NoNCSConnectionDetected":
        case "NoRouterConnectionDetected":
        case "NoInternetConnectionDetected":
        case "NoServerConnectionDetected" : 
        {
            return [
                    {
                        label: content?.actions.tryAgain || "Try Again",
                        action: tryAgain,
                        variant: "primary",
                        key:0
                    },
                    {
                        label: content?.actions.exit || "Exit Application",
                        action: handleExit,
                        variant: "secondary",
                        key:1
                    }
                ]
        }
        case "FailedHardwareCheck" : 
        case "SystemError" : 
        case "UpdateError" : 
        case "FailedVersionCheck" : 
        case "FailedSystemTimeCheck" : 
        {
            return [
                    {
                        label: content?.actions.exit || "Exit Application",
                        action: handleExit,
                        variant: "secondary",
                        key:0
                    }
                ]
        }
    }
  }
  const errorProps:ErrorPropsV2 ={
    iconSrc:errorTriangle,
    title:errorContent?.title || "",
    content:errorContent?.content || [],
    buttons:getButtonProps(errorType),
    errorCode:errorContent?.errorCode
  }
  return (
    <SplitLayout>
        <Error {...errorProps}/>
    </SplitLayout>
  )       
}
